<template>
  <section class="justify-center grid-list">
    <TeamCard v-for="(item, keyItems) in items" :key="keyItems" v-bind="item" />
  </section>
</template>

<script>
import TeamCard from "../cards/TeamCard.vue";

const _config = {
  mod: "management-team",
};

export default {
  props: {
    category: {
      type: Number,
    },
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list.filter(
        (item) => item.category.id == this.category
      );
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getList() {
      this.loading = true;

      this.$rest(_config.mod)
        .get()
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    TeamCard,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  width: 100%;
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(auto-fill, 270px);

  @media screen and (max-width: 599.9px) {
    gap: 12px;
    grid-template-columns: repeat(1, minmax(auto, 100%));
  }
}
</style>
